"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getObjectKey = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var getObjectKey = function getObjectKey(obj) {
  if (obj === null) {
    return 'null';
  }

  if (obj === undefined) {
    return 'undefined';
  }

  if (Object.prototype.toString.call(obj) === '[object Array]') {
    return "[".concat(obj.map(function (item) {
      return getObjectKey(item);
    }).join(','), "]");
  }

  if ((0, _typeof2["default"])(obj) === 'object') {
    return '{' + Object.entries(obj).sort(function (_ref, _ref2) {
      var _ref3 = (0, _slicedToArray2["default"])(_ref, 1),
          akey = _ref3[0];

      var _ref4 = (0, _slicedToArray2["default"])(_ref2, 1),
          bkey = _ref4[0];

      return akey.localeCompare(bkey);
    }).map(function (_ref5) {
      var _ref6 = (0, _slicedToArray2["default"])(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];

      return "\"".concat(key, "\":").concat(getObjectKey(value));
    }).join(',') + '}';
  }

  if (typeof obj === 'string') {
    return "\"".concat(obj, "\"");
  }

  if (typeof obj === 'number') {
    return obj;
  }

  return obj;
};

exports.getObjectKey = getObjectKey;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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